import { evaluateFormula } from '~/_shared/utils/number/evaluate.helpers';
import { getFormulaDemographicIds } from '~/exportReport/template/reportTemplate.helpers';

export const getReportFormulaValue = (formula: string, getDemographicValue: (demographicId: string) => number | null): string | null => {
  const lookup: Record<string, number> = {};
  const formulaDemographics = getFormulaDemographicIds(formula);
  for (const id of formulaDemographics) {
    try {
      const value = Number(getDemographicValue(id));
      if (value === null) {
        return null;
      }
      lookup[id] = value;
    }
    catch (e) {
      return null;
    }
  }

  const result = evaluateFormula(formula, lookup);
  if (result === null) {
    return null;
  }
  else {
    return result.toString();
  }
};
